import type { ReactNode } from "react";

import { cn } from "@/lib/utils";
import { mrpSkuDisplayUnitLabel } from "@/lib/mrpSkuUnitDisplay";

export function MrpSkuWithUnitLabel({
  sku,
  unit,
  className,
  unitClassName,
}: {
  sku: string;
  unit?: string | null;
  className?: string;
  unitClassName?: string;
}): ReactNode {
  const trimmedSku = sku.trim();
  if (trimmedSku === "") {
    return <span className={className}>—</span>;
  }

  const unitLabel = mrpSkuDisplayUnitLabel(unit);
  return (
    <span className={className}>
      {trimmedSku}
      {unitLabel != null ? (
        <>
          <span className="text-slate-400"> · </span>
          <span
            className={cn(
              "font-sans text-[0.92em] font-medium text-slate-500",
              unitClassName,
            )}
          >
            {unitLabel}
          </span>
        </>
      ) : null}
    </span>
  );
}
